import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsAppDownloadLinkResponse } from "../../Orchestrator/Types/Interface/ICmsAppDownloadLink";

type Result = IApiResponse<ICmsAppDownloadLinkResponse>;

let inFlight: Promise<Result> | null = null;

export async function getCmsAppDownloadLinkAndQr(): Promise<Result> {
  // Single-flight: concurrent callers share one request so we only hit the
  // network once per page load (clears on settle, not cached across reloads).
  if (inFlight) return inFlight;

  inFlight = (async () => {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getAppDownloadLinkAndQrAPI;

    const params = new URLSearchParams({
      "populate[play_store_qr][populate]": "populate",
      "populate[app_store_qr][populate]": "populate",
      locale: await getLocaleFromCookie()
    });

    const endpointWithParams = `${endpoint}?${params.toString()}`;
    return cmsApiRequest<ICmsAppDownloadLinkResponse>(endpointWithParams, "GET");
  })().finally(() => {
    inFlight = null;
  });

  return inFlight;
}
